/** Focus the global quick-add input (#quick-add-input). */
export const QUICK_ADD_INPUT_ID = 'quick-add-input';

export function focusQuickAddInput() {
  const quickAddInput = document.getElementById(QUICK_ADD_INPUT_ID);
  if (quickAddInput instanceof HTMLElement) {
    quickAddInput.focus();
  }
}
